import { render, staticRenderFns } from "./ColorSelection.vue?vue&type=template&id=71694676&scoped=true&"
import script from "./ColorSelection.vue?vue&type=script&lang=js&"
export * from "./ColorSelection.vue?vue&type=script&lang=js&"
import style0 from "./ColorSelection.vue?vue&type=style&index=0&id=71694676&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71694676",
  null
  
)

export default component.exports